export { default } from './BaseInstallInterstitial';
